/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Faq {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Faq as FaqModule } from "@bw/modules"

const Faq = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  questions,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <FaqModule questions={questions} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ...FaqModuleFragment
 *
 * This is also what you will get in the props of your Faq
 * resolver component.
 */
export const query = graphql`
  fragment FaqModuleFragment on FaqModule {
    questions {
      question
      answer
    }
  }
`

export { Faq }
